import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function mySessionsOneToOneReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.MY_SESSIONS_ONE_TO_ONE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.MY_SESSIONS_ONE_TO_ONE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.MY_SESSIONS_ONE_TO_ONE_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
